import axios from 'axios';
import { Dispatch } from 'react';
import {
    CLEAR_APPOINTMENT_STATE,
    CREATE_APPOINTMENT_FAILURE,
    CREATE_APPOINTMENT_REQUEST,
    CREATE_APPOINTMENT_SUCCESS,
    GET_APPOINTMENTS_FAILURE,
    GET_APPOINTMENTS_REQUEST,
    GET_APPOINTMENTS_SUCCESS,
    GET_APPOINTMENT_DETAILS_FAILURE,
    GET_APPOINTMENT_DETAILS_REQUEST,
    GET_APPOINTMENT_DETAILS_SUCCESS,
    OPEN_AMAZON_DOOR_FAILURE,
    OPEN_AMAZON_DOOR_REQUEST,
    OPEN_AMAZON_DOOR_SUCCESS,
    RESET_AMAZON_DOOR,
    SET_APPOINTMENT_CHAT_SESSION_FAILURE,
    SET_APPOINTMENT_CHAT_SESSION_REQUEST,
    SET_APPOINTMENT_CHAT_SESSION_SUCCESS,
} from '../constants/appointment.constant';
import { AnyIfEmpty } from 'react-redux';
import { MediaFile } from '../../../components/amenities/Amenities';
import { AppointmentAccessCodeProps } from '../../../components/appointments/AppointmentCard/AppointmentCard';
import { AlertObjectProps } from '../../../template/ProtectedRoutes';
import { amazonDoorProps } from '../../../components/vendorAppointments/VendorAppointments';

export interface appointment {
    reservedDate: string;
    start_time: string;
    end_time: string;
    availability: string;
    user: string;
    code: string;
    id: string;
    created_at: Date;
    updated_at: Date;
}

export interface deleteUserAppointmentProps {
    isModified: boolean;
    reservedDate?: string;
    start_time?: string;
}

export interface AccessCodeProps {
    file: File;
    appointmentId: string;
}

export interface TourDetails {
    appointmentId: string;
    isDoorClosed: boolean;
    isKeyReturn: boolean;
}

export interface AmenitiesObject {
    id: string;
    name: string;
    location: string;
    mediaFiles: MediaFile[];
    amenityWebLinkTitle: string | null;
    amenityWebLink: string | null;
    description: string;
    latitude: number;
    longitude: number;
}

export interface AppointmentMapDetails {
    appointmentId: string;
    start_time: string;
    end_time: string;
    reservedDate: string;
    openViaSlug: string | null;
    openAIThreadId: string | null;
    openAITourVectorId: string | null;
    openAITourFileId: string | null;
    userId: string;
    timeZone: string;
    unitMapId: string | null;
    openViaChatBotPropertyId: string | null;
    leasingAgentNumber: string;
    leasingAgentEmailId: string;
    unitMapAssetId: string | null;
    appLink: string | null;
    mappedInId: string | null;
    mapFilePath: string | null;
    mappedInFloorId: string | null;
    locationName?: string;
}

const createAppointmentRequest = () => {
    return {
        type: CREATE_APPOINTMENT_REQUEST,
    };
};

const createAppointmentSuccess = (appointment: appointment) => {
    return {
        type: CREATE_APPOINTMENT_SUCCESS,
        payload: appointment,
    };
};

const createAppointmentFailure = (appointmentError: string) => {
    return {
        type: CREATE_APPOINTMENT_FAILURE,
        payload: appointmentError,
    };
};

const clearAppointmentStateAction = () => {
    return {
        type: CLEAR_APPOINTMENT_STATE,
    };
};

const getAppointmentDetailsRequest = () => {
    return {
        type: GET_APPOINTMENT_DETAILS_REQUEST,
    };
};

const getAppointmentDetailsSuccess = (appointments: string) => {
    return {
        type: GET_APPOINTMENT_DETAILS_SUCCESS,
        payload: appointments,
    };
};

const getAppointmentDetailsFailure = (appointmentDetailsError: string) => {
    return {
        type: GET_APPOINTMENT_DETAILS_FAILURE,
        payload: appointmentDetailsError,
    };
};

export const createAppointment = (appointment: AnyIfEmpty<object>, navigate?: AnyIfEmpty<object>) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(createAppointmentRequest());
        axios
            .post(`/appointments`, appointment)
            .then(async (response) => {
                if (response.data.statusCode === 201) {
                    dispatch(createAppointmentSuccess(response.data.appointment));
                    await navigate?.('/appointments');
                } else {
                    // throw new Error(response.data.message);
                    dispatch(createAppointmentFailure(response.data.message));
                }
            })
            .catch((error) => {
                dispatch(createAppointmentFailure(error?.response?.data?.message));
            });
    };
};

const getAppointmentsRequest = () => {
    return {
        type: GET_APPOINTMENTS_REQUEST,
    };
};

const getAppointmentsSuccess = (appointments: string) => {
    return {
        type: GET_APPOINTMENTS_SUCCESS,
        payload: appointments,
    };
};

const getAppointmentsFailure = (appointementsError: string) => {
    return {
        type: GET_APPOINTMENTS_FAILURE,
        payload: appointementsError,
    };
};

const setAppointmentChatSessionRequest = () => {
    return {
        type: SET_APPOINTMENT_CHAT_SESSION_REQUEST,
    };
};

const setAppointmentChatSessionSuccess = (appointments: string) => {
    return {
        type: SET_APPOINTMENT_CHAT_SESSION_SUCCESS,
        payload: appointments,
    };
};

const setAppointmentChatSessionFailure = (chatSessionError: string) => {
    return {
        type: SET_APPOINTMENT_CHAT_SESSION_FAILURE,
        payload: chatSessionError,
    };
};

export const clearAppointmentState = () => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(clearAppointmentStateAction());
    };
};

export const getUserAppointments = (type: string) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAppointmentsRequest());
        axios
            .get('/appointments/user', {
                params: {
                    sorting: type,
                },
            })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(getAppointmentsSuccess(response.data.appointment));
                } else {
                    throw new Error(response.data.message);
                }
            })
            .catch((error) => dispatch(getAppointmentsFailure(error)));
    };
};

export const deleteUserAppointment = (id: string, type: string, appointmentDetail: deleteUserAppointmentProps) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        axios.delete(`appointments/${id}`, { data: appointmentDetail }).then((response) => {
            if (response.data.statusCode === 200) {
                dispatch(getUserAppointments(type));
            }
        });
    };
};

export const getAppointmentDetails = (id: string) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(getAppointmentDetailsRequest());
        axios
            .get(`appointments/${id}`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(getAppointmentDetailsSuccess(response?.data));
                } else {
                    dispatch(getAppointmentDetailsFailure(response?.data?.message));
                }
            })
            .catch((error) => {
                dispatch(getAppointmentDetailsFailure(error));
            });
    };
};

export const setAppointmentChatSession = (id: string, chatSession: any) => {
    return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(setAppointmentChatSessionRequest());
        axios
            .patch(`appointments/chat-session`, {
                appointmentId: id,
                chatSession: chatSession,
            })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    dispatch(setAppointmentChatSessionSuccess(response?.data));
                } else {
                    dispatch(setAppointmentChatSessionFailure(response?.data?.message));
                }
            })
            .catch((error) => {
                dispatch(setAppointmentChatSessionFailure(error));
            });
    };
};

export const requestAccessCode = (
    appointmentObj: AccessCodeProps,
    onSuccess: (accessCode: string) => void,
    onFailure: (message: string) => void,
) => {
    return () => {
        axios
            .patch(`appointments/generate-access-code`, appointmentObj)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    onSuccess(response.data.code);
                } else {
                    onFailure(response.data?.message);
                }
            })
            .catch((error) => {
                onFailure(error.response.data.message);
            });
    };
};

export const storeTourDetails = (tourObj: TourDetails, onTourSuccess: (message: string) => void, onFailure: (message: string) => void) => {
    return () => {
        axios
            .patch(`appointments/store-tour-details`, tourObj)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    onTourSuccess(response.data.message);
                } else {
                    onTourSuccess(response.data.message);
                }
            })
            .catch((error) => {
                onTourSuccess(error.response.data.message);
            });
    };
};

export const getAppointmentMapDetails = (
    appointmentId: string,
    onSuccess: (appointment: AppointmentMapDetails, amenity: AmenitiesObject[] | null) => void,
    onFailure: (message: string, statusCode: string) => void,
) => {
    return () => {
        axios
            .get(`appointments/map-details/${appointmentId}`)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    onSuccess(response.data.appointment, response?.data?.amenities || null);
                } else {
                    onFailure(response.data.message, response.data.statusCode);
                }
            })
            .catch((error) => {
                onFailure(error.response.data.message, error.response.data.statusCode);
            });
    };
};

const openAmazonDoorRequest = () => {
    return {
        type: OPEN_AMAZON_DOOR_REQUEST,
    };
};

const openAmazonDoorSuccess = (appointment: appointment) => {
    return {
        type: OPEN_AMAZON_DOOR_SUCCESS,
        payload: appointment,
    };
};

const openAmazonDoorFailure = (appointmentError: string) => {
    return {
        type: OPEN_AMAZON_DOOR_FAILURE,
        payload: appointmentError,
    };
};
export const openAmazonDoor = (appointment: amazonDoorProps, onSuccess?: (id?: string) => void,onFailure?:(error: string)=> void) => {
    return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
        dispatch(openAmazonDoorRequest());
        try {
            const response = await axios.post(`/amazon-access-door`, appointment);
            if (response.data.statusCode === 200) {
                dispatch(openAmazonDoorSuccess(response.data));
                const responseMeg = response.data.message;
                onSuccess?.(responseMeg);
            } else {
                dispatch(openAmazonDoorFailure(response.data.message));
                onFailure?.(response?.data?.message)
            }
        } catch (error: string | any) {
            dispatch(openAmazonDoorFailure(error.response?.data?.message));
            onFailure?.(error.response?.data?.message || "Unable to open locker")
        }
    };
};

export const resetAmazonDoor = () => {
    return {
        type: RESET_AMAZON_DOOR,
    };
};

export const getAccessCode = (
    appointment: AppointmentAccessCodeProps,
    onSuccess: (accessCode: string) => void,
    onBMSSuccess: ({ appointmentId, entryExitCount, message }: { message: string; appointmentId: string; entryExitCount: number }) => void,
    onFailure: (message: string) => void,
) => {
    return async () => {
        axios
            .get(`/appointments/get-access-code`, {
                params: {
                    latitude: appointment.latitude,
                    longitude: appointment.longitude,
                    appointmentId: appointment.appointmentId,
                    unitNumber: appointment?.unitNumber,
                },
            })
            .then(async (response) => {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.code) {
                        onSuccess(response?.data?.code);
                    }

                    if (response?.data?.locker) {
                        onBMSSuccess({
                            message: response?.data?.message,
                            appointmentId: response?.data?.locker?.appointmentId,
                            entryExitCount: response?.data?.locker?.entryExitCount,
                        });
                    }
                } else {
                    onFailure(response?.data?.message);
                }
            })
            .catch((error) => {
                onFailure(error?.response?.data?.message);
            });
    };
};

export const outSideGeoLocationAlert = (appointmentObject: AlertObjectProps, onSuccess: (message: string) => void) => {
    return async () => {
        axios
            .patch(`/appointments/alert-admin-geo-fencing`, {
                appointmentId: appointmentObject?.appointmentId,
                tourLatitude: appointmentObject?.tourLatitude,
                tourLongitude: appointmentObject?.tourLongitude,
            })
            .then(async (response) => {
                if (response?.data?.statusCode === 200) {
                    onSuccess(response?.data?.message);
                } else {
                    console.error(response?.data?.message);
                }
            })
            .catch((error) => {
                console.error(error?.response?.data?.message);
            });
    };
};
